// 숫자 3자리 콤마찍어줌
export function numberWithCommas(num: number | null) {
  if (!num) {
    return '';
  }

  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
